export const summaryDetails = ({ BeURL, profileSummary, address, currentUser, navigate,setLoading }) => {
    fetch(`${BeURL}/summaryInformation`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ profileSummary, address })
    })
        .then(res => res.json())
        .then(data => {
            setLoading(false)
            if (data.success) {
                alert(data.message)
                navigate(`/update-account/education?userId=${currentUser?._id}`)
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            setLoading(false)
            console.log('Error in summary and address details:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
